import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {
  ACCOUNT_ADD_BUSINESS_INFORMATION_LINK,
  ACCOUNT_EDIT_BUSINESS_INFORMATION_LINK,
} from '~shared/constants/links.constants';

import { AccountInfoComponent } from './components/account-info/account-info.component';
import { AccountDetailsComponent } from './components/account-details/account-details.component';
import { AddBusinessInfoComponent } from './components/add-business-info/add-business-info.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ChangeEmailComponent } from './components/change-email/change-email.component';
import { EditBusinessInfoComponent } from './components/edit-business-info/edit-business-info.component';
import { EditPrivateInfoComponent } from './components/edit-private-info/edit-private-info.component';
import { EntrepreneurStatusGuard } from './guards/entrepreneur-status.guard';
import { BusinessInfoCancellationGuard } from './guards/business-info-cancellation.guard';
import { AccountInfoUtil } from './utils/account-info.util';

export const accountManagementRoutes: Routes = [
  {
    path: '',
    component: AccountInfoComponent,
    children: [
      {
        path: 'add-business-info',
        component: AddBusinessInfoComponent,
        canActivate: [EntrepreneurStatusGuard],
        canDeactivate: [BusinessInfoCancellationGuard],
        data: {
          title: 'TITLE.PAGE.ACCOUNT.INFO.ADD_BUSINESS_INFO',
          redirectUrl: ACCOUNT_EDIT_BUSINESS_INFORMATION_LINK,
          canAccessRoute: AccountInfoUtil.isStatusValidationInProgress,
        },
      },
      {
        path: 'edit-business-info',
        component: EditBusinessInfoComponent,
        canActivate: [EntrepreneurStatusGuard],
        data: {
          title: 'TITLE.PAGE.ACCOUNT.INFO.EDIT_BUSINESS_INFO',
          redirectUrl: ACCOUNT_ADD_BUSINESS_INFORMATION_LINK,
          canAccessRoute: AccountInfoUtil.isStatusValidated,
        },
      },
      {
        path: 'edit-private-info',
        component: EditPrivateInfoComponent,
        data: { title: 'TITLE.PAGE.ACCOUNT.INFO.EDIT_PRIVATE_INFO' },
      },
      {
        path: 'change-password',
        component: ChangePasswordComponent,
        data: { title: 'TITLE.PAGE.ACCOUNT.INFO.CHANGE_PASSWORD' },
      },
      {
        path: 'change-email',
        component: ChangeEmailComponent,
        data: { title: 'TITLE.PAGE.ACCOUNT.INFO.CHANGE_EMAIL' },
      },
      {
        path: '',
        pathMatch: 'full',
        component: AccountDetailsComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(accountManagementRoutes)],
  exports: [RouterModule],
})
export class AccountManagementRoutingModule {}
